<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>            
            <el-form-item label="所属代理商：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="套餐名称 ：">
                <el-input v-model.trim="searchForm.packageName" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="充值类型：">
                <el-select v-model="searchForm.investType" clearable>
                    <el-option label="首次充值" value="0"></el-option>
                    <el-option label="续费充值" value="1"></el-option>
                </el-select>
            </el-form-item>
                       <el-form-item label="订单状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option v-for="item in orderState" :key="item.description" :label="item.description" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="通道：">
                <el-input v-model="searchForm.alias" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否秒返：">
                <el-select v-model="searchForm.isCashback" clearable>
                    <el-option label="已秒返" value="2"></el-option>
                    <el-option label="未秒返" value="3"></el-option>
                    <el-option label="未开启" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAgentOrderListHandle">搜索查询</el-button>
                <el-button type="primary" @click="open">导 出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  > 
            <el-table-column prop="orderNo" label="订单号" width="240"></el-table-column>
            <el-table-column prop="agentName" label="所属代理商" width="140"></el-table-column>
            <el-table-column prop="iccid" label="ICCID号" width="180"></el-table-column>
            <el-table-column prop="packageName" label="套餐名称"></el-table-column>
            <el-table-column prop="priceRmb" label="下单金额(元)" width="100"></el-table-column>
             <el-table-column prop="backPriceRmb" label="退款金额(元)" width="100"></el-table-column>
            <el-table-column prop="payStateName" label="支付状态" width="100"></el-table-column>
            <el-table-column prop="isCashbackName" label="是否秒返" width="100"></el-table-column>
            <el-table-column prop="alias" label="通道" width="100"></el-table-column>
            <el-table-column prop="supplierTypeCodeName" label="卡来源" width="100"></el-table-column>
            <el-table-column prop="investTypeName" label="充值类型" width="100"></el-table-column>
            <el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showOrderDetail(scope.row)">详情</el-button>
                    <!-- <el-button type="text" size="small">退款</el-button> -->
                    <!-- <el-button type="text" size="small">秒返记录</el-button> -->
                </template>                
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

        <el-dialog :append-to-body="true"  title="订单详情" :visible.sync="orderDetailVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{orderDetailForm.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>所属代理商：</label>
                <span>{{orderDetailForm.agentName}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{orderDetailForm.iccid}}</span>
            </div>
            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{orderDetailForm.packageName}}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{orderDetailForm.priceRmb}} 元</span>
            </div>
            <div class="lineInDialog">
                <label>支付状态：</label>
                <span>{{orderDetailForm.payStateName}}</span>
            </div>
            <div class="lineInDialog">
                <label>卡来源：</label>
                <span>{{orderDetailForm.supplierTypeCodeName}}</span>
            </div>
            <div class="lineInDialog">
                <label>我的佣金：</label>
                <span>{{orderDetailForm.commissionRmb}} 元</span>
            </div>
            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{orderDetailForm.createTime}}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>            
        </el-dialog>   
    </div>
</template>
<script>
import {getOrderList, getSecondBackList,exportOrderInfo, getOrderStateList, getOrderSourceList, backMoney, backMoneyDetail,resetOrderState} from '@/api/order.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                packageName: '',
                iccid: '',
                orderNo: '',
                investType: '',
                alias: '',
                isCashback: '',
                time: '',
                payState:''
            },
            orderDetailVisible: false,
            orderDetailForm: {},
            orderState: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        getAgentOrderListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('order/down/pkg/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })  
        },
        //导出
        open(){
            this.$confirm('确定要导出吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
                // type: 'warning'
            }).then(() => {
                var data = JSON.parse(JSON.stringify(this.searchForm));
                data.agentId = localStorage.getItem('agentId');
                if(data.time != ''){
                    data.startTimeString = data.time[0] + ' 00:00:00'; 
                    data.endTimeString = data.time[1] + ' 23:59:59';
                }else{
                    data.startTimeString = '';
                    data.endTimeString = '';
                }
                delete data.time; 
                this.exportExcel('/mould/download/down/pkgList', data);
            }).catch(() => {        
            });
        },
        showOrderDetail(row){
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentOrderListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getAgentOrderListHandle();
        }
      
    },
    created(){
              getOrderStateList().then(res => {
            if(res.data.code == 200){
                this.orderState = res.data.data;
            }
        })
        this.getAgentOrderListHandle();
    }
}
</script>
<style lang="less" scoped>

</style>

